import { cultSeries } from "@/mocks/manga";

export default function CultSection() {
  return (
    <section id="cult" className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
          <div>
            <p className="text-xs tracking-widest text-accent-400 mb-2">邪典专题 · 栏目编辑精选</p>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
              邪典经典剧场
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-sm">
            离经叛道的主题、实验性的叙事，这些作品总在规则的边缘试探。
          </p>
        </div>

        <div className="space-y-4 md:space-y-5">
          {cultSeries.map((m, i) => (
            <article
              key={m.id}
              className="group grid grid-cols-1 md:grid-cols-3 rounded-lg overflow-hidden bg-background-100 border border-background-300/40 hover:border-accent-500/50 transition-colors"
            >
              <div className="relative md:col-span-1 aspect-[3/2] md:aspect-auto overflow-hidden">
                <img
                  src={m.cover}
                  alt={`${m.title} 邪典漫画经典作品`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-background-950/70 text-accent-400 text-xs font-heading tracking-wider">
                  NO.{String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="md:col-span-2 p-5 md:p-7 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-3 flex-wrap">
                  <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                    {m.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded bg-secondary-200/40 text-secondary-300 text-xs">
                    {m.status}
                  </span>
                </div>
                <p className="text-sm text-foreground-400 leading-relaxed mb-4 max-w-2xl">
                  {m.desc}
                </p>
                <div className="flex flex-wrap gap-1.5 mb-5">
                  {m.tags.map((tag) => (
                    <span key={tag} className="px-2.5 py-0.5 rounded bg-accent-200/20 text-accent-300 text-xs">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center gap-5 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-star-fill text-accent-400"></i>
                    {m.rating.toFixed(1)} 分
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-book-2-line"></i>
                    {m.chapter}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-eye-line"></i>
                    {m.views} 人阅读
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}